/*jslint browser: true*/
/*eslint-env browser*/
/*global jQuery*/

jQuery(document).ready(function ($) {
	'use strict';

	$(document).foundation();

	$("#lightgallery").lightGallery({
		//thumbWidth: 90,
		//thumbHeight: '60px'
	});

	// sort select options by city
	/*var options = $("#filterText option");                    // Collect options         
	options.detach().sort(function(a,b) {               // Detach from select, then Sort
		var at = $(a).val();
		var bt = $(b).val();         
		return (at > bt)?1:((at < bt)?-1:0);            // Tell the sort function how to order
	});
	options.appendTo("#filterText");*/

	// accordion and equalizer
	/* $('.accordion-item').on('click', function (event, accordion) {
		$('[data-equalizer]').foundation('_reflow');
	}); */

   /*  var sel = $('#filterText');
	var selected = sel.val(); // cache selected value, before reordering
	var opts_list = sel.find('option');
	opts_list.sort(function(a, b) { return $(a).val() > $(b).val() ? 1 : -1; });
	sel.html('').append(opts_list);
	sel.val(selected); */

	// támogatók carousel
	$('#tamogatok .owl-carousel').owlCarousel(
		{
			/*items: 4,*/
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 50,
			dots: true,
			navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"],
			responsive: {
				0: {
					items: 2,
					nav: false
				},
				640: {
					items: 4,
					nav: false
				},
				1024: {
					items: 6,
					nav: true
				}
			}
		}
	);
	$('#nemzetkozi .owl-carousel, #autovasarlas .owl-carousel').owlCarousel(
		{
			/*items: 4,*/
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 50,
			dots: true,
			navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"],
			responsive: {
				0: {
					items: 2,
					nav: false
				},
				640: {
					items: 4,
					nav: false
				},
				1024: {
					items: 6,
					nav: true
				}
			}
		}
	);
	$('#partnerek .owl-carousel').owlCarousel(
		{
			/*items: 4,*/
			/* autoWidth: true, */
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 50,
			dots: true,
			navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"],
			responsive: {
				0: {
					items: 2,
					nav: false
				},
				640: {
					items: 4,
					nav: false
				},
				1024: {
					items: 6,
					nav: true
				}
			}
		}
	);

	$('#slider .owl-carousel').owlCarousel(
		{
			items: 1,
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 0,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: false,
			dots: true,
			/* navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"], */
		}
	);
	$('#slider_en .owl-carousel').owlCarousel(
		{
			items: 1,
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 0,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: false,
			dots: true,
			/* navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"], */		
		}
	);

	$('.eloado .owl-carousel').owlCarousel(
		{
			items: 1,
			loop: true,
			autoplay: true,
			smartSpeed: 1200,
			autoplayHoverPause: true,
			margin: 0,
			//animateOut: 'fadeOut',
			//animateIn: 'fadeIn',
			nav: false,
			dots: true,
			/* navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"], */		
		}
	);
   
	// grid packery galéria
	var $grid = $('.grid').packery({
		itemSelector: '.grid-item',
		columnWidth: '.grid-sizer',
		percentPosition: true
	  });
	  
	  $grid.imagesLoaded().progress( function() {
		$grid.packery();
	  });

	// angol placeholder search
	$('.page-template-angol form.search-form input[type="search"], .category-international_events form.search-form input[type="search"], .post-type-archive-gallery form.search-form input[type="search"], .single-gallery form.search-form input[type="search"], .tax-gallery_year form.search-form input[type="search"]').attr('placeholder', 'Search ...');

	// accordion scroll to top
	$('.rolunk .accordion-title').click(function() {
		var $this = this;
		setTimeout(function(){
			$('html,body').animate({scrollTop: $($this).closest('.accordion').find('.is-active').offset().top}, 'slow');
		}, 250);
	}); 

	// select város minden accordion lenyit
	$('#filterText').on('change', function() {
		$('li.accordion-item').addClass('is-active').children('.accordion-content').attr('aria-hidden', 'false').css('display','block');
	});
	/* $('#filterTextUj').on('change', function() {
		$('li.accordion-item').addClass('is-active').children('.accordion-content').attr('aria-hidden', 'false').css('display','block');
	}); */

	// gomb felirat csere klikkre
	$('#fld_5193388_1-wrap input[type="submit"]').on('click', function(){
		$(this).attr('value', 'Feldolgozás...');
		setTimeout(function(){
			$('#fld_5193388_1-wrap input[type="submit"]').attr('value', 'Küldés');
		  }, 3000);
	});

	//összes megye beikszelése
	/*$('#fld_5933384_1-wrap').append('<div class="checkbox"><label for="osszesmegye"><input type="checkbox" class="" id="osszesmegye"> Összes megye kiválasztása (ha országos a kedvezmény)</label></div>');

	$("#osszesmegye").click(function () {
		$('#fld_5933384_1-wrap input:checkbox').not(this).prop('checked', this.checked);
	});*/


	//több-kevesebb click
	$('.tobb').click(function(){
		var text = $(this);
		var exp = $(this).prev('.bekoszont');
		var newHeight;
		//text.toggleClass( 'kevesebb' );
		if (text.hasClass('kevesebb')) {
			exp.css('oveflow', 'visible');
			exp.css('height', '420px');
			newHeight = exp.height();
			exp.css('height', 'auto');
			exp.css('overflow', 'hidden');
			$(this).prev('.bekoszont').animate({height: newHeight+'px'}, 'slow');
			$(this).removeClass('kevesebb');
		} else {
			exp.css('oveflow', 'hidden');
			exp.css('height', 'auto');
			newHeight = exp.height();
			exp.css('height', '420px');
			exp.css('overflow', 'visible');
			$(this).prev('.bekoszont').animate({height: newHeight+'px'}, 'slow');
			$(this).addClass('kevesebb');
		}
	});  

	// kereses gomb
	$('li i').click( function() {
		$(this).toggleClass('active');
		$('#kereses').toggle();
	});

	// szűrő
	var $items = $('.szurendo');
	var $btns = $('.button').click(function() {
		if (this.id == 'all') {
			$items.show();
		} else {
			var $el = $('.' + this.id).show();
			$items.not($el).hide();
		}
		$btns.removeClass('active');
		$(this).addClass('active');
	})

});
